<template>
  <el-select :size="size"
             :value="value"
             :multiple="multiple"
             :collapse-tags="collapseTags"
             :filterable="filterable"
             :disabled="disabled"
             :clearable="clearable"
             value-key="id"
             @change="change($event)" :class="{'width100': width100}">
    <el-option v-for="contractConfigItem in contractConfigItems" :key="contractConfigItem.id"
               :value="contractConfigItem" :label="contractConfigItem.billingItem"
    ></el-option>
  </el-select>
</template>

<script>
  import BillingServer from '@/api/billing';
  export default {
    name: "ContractConfigItemSelect",
    props: {
      size: {},
      value: {},
      multiple: {},
      collapseTags: {},
      filterable: {},
      clearable: {},
      disabled: {},

      width100: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        contractConfigItems: [],
      };
    },
    methods: {
      load() {
        BillingServer.contract.getContractConfigItems().then(res => {
          if (res.data.success) {
            this.contractConfigItems = res.data.data == null ? [] : res.data.data;
            this.$emit('loaded', this.contractConfigItems);
          } else {
            this.contractConfigItems = [];
            this.$message.error(res.data.responseMessage)
          }
        }, error => {
          this.$message.error(error || '加载合同配置信息数据异常')
        });
      },
      change(event) {
        this.$emit('input', event);
        this.$emit('change', event);
      },
    },
    mounted() {
      this.load();
    }
  }
</script>

<style scoped>

</style>
